import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { updateCustomName } from "reduxSlices/customNamesSlice"
import { CustomNameShape } from "utils/propTypeShapes"
import { DEFAULT_NAMES } from "utils/customNameHelpers"
import { squish } from "utils/stringHelpers"
import ItemRow from "shared/ItemRow"
import { PrimaryButton } from "shared/buttons"
import { TextInput } from "shared/inputs"
import CustomNamePreview from "./CustomNamePreview"

const CustomNamesListItemNameSection = ({ customName }) => {
  const dispatch = useDispatch()
  const { key, name: currentName } = customName

  const [rawName, setRawName] = useState(currentName)

  useEffect(() => {
    setRawName(currentName)
  }, [currentName])

  const newName = squish(rawName)

  const updateRawName = (value) => {
    setRawName(value.trimStart())
  }

  const update = (event) => {
    event.preventDefault()

    if (!newName || newName === currentName) return

    dispatch(updateCustomName({ key, name: newName }))
  }

  const formId = `update-custom-name-form-${key}`

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <span>Custom Name</span>
      )}
      itemRowHeaderContentClassName="font-semibold"
      itemRowBody={(
        <div className="flex flex-col gap-8 sm:gap-4 w-full">
          <form className="flex flex-col sm:flex-row gap-4 w-full" id={formId} onSubmit={update}>
            <TextInput className="grow bordered-base-input !bg-white" onChange={updateRawName} value={rawName} />
            <PrimaryButton
              disabled={!newName || newName === currentName}
              form={formId}
              text="Save"
              type="submit"
            />
          </form>
          {newName && <CustomNamePreview name={newName} />}
          <p className="text-xs text-dark">
            {`The name this organization uses in place of "${DEFAULT_NAMES[key]}".`}
          </p>
        </div>
      )}
    />
  )
}

CustomNamesListItemNameSection.propTypes = {
  customName: CustomNameShape.isRequired,
}

export default CustomNamesListItemNameSection
